'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFilterValues = function getFilterValues(_ref, options) {
  var filters = _ref.filters;
  var onlyFilters = options.onlyFilters,
      overrideFilters = options.overrideFilters;


  if (onlyFilters) {
    var resultingFilters = {};

    onlyFilters.forEach(function (filter) {
      if (filters[filter]) {
        resultingFilters[filter] = filters[filter];
      }
    });

    return resultingFilters;
  }

  if ((typeof overrideFilters === 'undefined' ? 'undefined' : (0, _typeof3.default)(overrideFilters)) === 'object') {
    return (0, _extends3.default)({}, filters, overrideFilters);
  }

  return filters;
};

exports.default = getFilterValues;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/getFilterValues.js
// module id = 810
// module chunks = 0